/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface VehicleDto
 */
export interface VehicleDto {
    /**
     *
     * @type {number}
     * @memberof VehicleDto
     */
    vehicleId?: number;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    registrationPlate?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    jurisdiction?: VehicleDtoJurisdictionEnum;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    friendlyName?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    make?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    model?: string;
    /**
     *
     * @type {number}
     * @memberof VehicleDto
     */
    year?: number;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    colour?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    vehicleType?: VehicleDtoVehicleTypeEnum;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    vin?: string;
    /**
     *
     * @type {number}
     * @memberof VehicleDto
     */
    batteryCapacityKwh?: number;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    macAddress?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof VehicleDto
     */
    connectorTypes?: Array<VehicleDtoConnectorTypesEnum>;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    notes?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleDto
     */
    status?: VehicleDtoStatusEnum;
    /**
     *
     * @type {Date}
     * @memberof VehicleDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof VehicleDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const VehicleDtoJurisdictionEnum = {
    Unknown: "Unknown",
    Act: "ACT",
    Nsw: "NSW",
    Nt: "NT",
    Qld: "QLD",
    Sa: "SA",
    Tas: "TAS",
    Vic: "VIC",
    Wa: "WA",
    National: "National",
} as const;
export type VehicleDtoJurisdictionEnum =
    (typeof VehicleDtoJurisdictionEnum)[keyof typeof VehicleDtoJurisdictionEnum];

/**
 * @export
 */
export const VehicleDtoVehicleTypeEnum = {
    Unknown: "Unknown",
    Bev: "BEV",
    Phev: "PHEV",
    Fcev: "FCEV",
} as const;
export type VehicleDtoVehicleTypeEnum =
    (typeof VehicleDtoVehicleTypeEnum)[keyof typeof VehicleDtoVehicleTypeEnum];

/**
 * @export
 */
export const VehicleDtoConnectorTypesEnum = {
    Unknown: "Unknown",
    ChAdeMo: "CHAdeMO",
    Ccs: "CCS",
    Ccs2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    Mcs: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;
export type VehicleDtoConnectorTypesEnum =
    (typeof VehicleDtoConnectorTypesEnum)[keyof typeof VehicleDtoConnectorTypesEnum];

/**
 * @export
 */
export const VehicleDtoStatusEnum = {
    Inactive: "Inactive",
    Active: "Active",
    Archived: "Archived",
} as const;
export type VehicleDtoStatusEnum =
    (typeof VehicleDtoStatusEnum)[keyof typeof VehicleDtoStatusEnum];

/**
 * Check if a given object implements the VehicleDto interface.
 */
export function instanceOfVehicleDto(value: object): value is VehicleDto {
    return true;
}

export function VehicleDtoFromJSON(json: any): VehicleDto {
    return VehicleDtoFromJSONTyped(json, false);
}

export function VehicleDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): VehicleDto {
    if (json == null) {
        return json;
    }
    return {
        vehicleId: json["vehicleId"] == null ? undefined : json["vehicleId"],
        registrationPlate:
            json["registrationPlate"] == null
                ? undefined
                : json["registrationPlate"],
        jurisdiction:
            json["jurisdiction"] == null ? undefined : json["jurisdiction"],
        friendlyName:
            json["friendlyName"] == null ? undefined : json["friendlyName"],
        make: json["make"] == null ? undefined : json["make"],
        model: json["model"] == null ? undefined : json["model"],
        year: json["year"] == null ? undefined : json["year"],
        colour: json["colour"] == null ? undefined : json["colour"],
        vehicleType:
            json["vehicleType"] == null ? undefined : json["vehicleType"],
        vin: json["vin"] == null ? undefined : json["vin"],
        batteryCapacityKwh:
            json["batteryCapacityKwh"] == null
                ? undefined
                : json["batteryCapacityKwh"],
        macAddress: json["macAddress"] == null ? undefined : json["macAddress"],
        connectorTypes:
            json["connectorTypes"] == null ? undefined : json["connectorTypes"],
        notes: json["notes"] == null ? undefined : json["notes"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        status: json["status"] == null ? undefined : json["status"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function VehicleDtoToJSON(value?: VehicleDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        vehicleId: value["vehicleId"],
        registrationPlate: value["registrationPlate"],
        jurisdiction: value["jurisdiction"],
        friendlyName: value["friendlyName"],
        make: value["make"],
        model: value["model"],
        year: value["year"],
        colour: value["colour"],
        vehicleType: value["vehicleType"],
        vin: value["vin"],
        batteryCapacityKwh: value["batteryCapacityKwh"],
        macAddress: value["macAddress"],
        connectorTypes: value["connectorTypes"],
        notes: value["notes"],
        organisationId: value["organisationId"],
        status: value["status"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
